<template>
  <div class="detail-table" v-resize="onResize">
    <div class="action-bar" v-if="windowSize > 600">
      <v-checkbox
        @change="push_all()"
        v-model="checkbox_all"
        hide-details
      ></v-checkbox>
      <!-- value="red" -->
      <div class="subtitle">Action</div>
      <div style="border:0" class="btn-filter">
        Print Label
       
      </div>
      <v-btn
        :disabled="this.select_order.length == 0 ? true : false"
        rounded
        @click="confirmAction"
        class="ok"
        >Submit</v-btn
      >
      <div class="count-subtitle">
        พบ {{ data.length }} รายการ  (เลือกแล้ว
        {{ this.select_order.length }} รายการ)
      </div>
    </div>
    <div class="action-bar" v-else style="padding:5px 0 5px 0">
      <div class="count-subtitle" style="">พบ {{ data.length }} รายการ</div>
    </div>
    <div
      class="table d-flex flex-wrap justify-center"
    >

    <div v-if="loading_status"  style="z-index:1;position: absolute;">
      <v-progress-circular
      :size="100"
      color="primary"
      indeterminate
    ></v-progress-circular>
    </div>
    
      <div
        id="test"
        :class="[
         ( row.disable != 1 &&
          find(row.purchase_id) &&
          row.order_status == 'Delivery')
            ? 'card selected'
            : 'card',
          row.disable == 1 ? 'card disable' : ''
        ]"
        v-for="(row, index) in data"
        :key="'card-' + index + '-' + row.purchase_id"
      >
        <div class="row-card" style="padding-left: 10px;">
          <div style="display:flex;width:100%">
            <div style="padding-top: 0px;width:7%">

            <div v-if="checkBox(row.disable , row.order_status , actionOrder)" >
              <v-checkbox
                v-model="select_order"
                :value="row.purchase_id"
                hide-details
              ></v-checkbox>
            </div>
            <div v-else>
              <v-checkbox
                :disabled="true"
                v-model="checkbox_true"
                hide-details
              ></v-checkbox>
            </div>
<!-- 
              <v-checkbox
                v-if="row.disable == 0 && row.order_status != 'Complete'  "
                :disabled="true"
                v-model="checkbox_true"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-else-if="row.disable == 0  && actionOrder == 'Disable' "
                v-model="select_order"
                :value="row.purchase_id"
                hide-details
              ></v-checkbox>
              
              <v-checkbox
                v-else-if="actionOrder == 'Resend' && ( row.order_status == 'Complete' || row.order_status == 'Deliverling' )  "
                v-model="select_order"
                :value="row.purchase_id"
                hide-details
              ></v-checkbox> -->
            </div>
            <div class="title-card" style="padding-top: 5px;">
              หมายเลขคำสั่งซื้อ
            </div>
            <div class="value-card" style="padding-top: 5px;">
              {{ row.purchase_id }}
            </div>
          </div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">Order Ref.</div>
          <div class="value-card">{{row.order_num }}</div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">ชื่อลูกค้า</div>
          <div class="value-card">{{ row.cus_name }} {{ row.cus_surname }}</div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">ชื่อผู้ผลิต</div>
          <div class="value-card">{{ row.sup_name }} {{ row.sup_surname }}</div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">วันที่สั่งซื้อ</div>
          <div class="value-card">{{ formatDate(row.order_date) }}</div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">วันที่จัดส่ง</div>
          <div class="value-card">
            {{ formatDate(row.order_delivery_date) }}
          </div>
        </div>
        <div class="row-card">
          <div style="width:7%"></div>
          <div class="title-card">วันที่ส่งสำเร็จ</div>
          <div class="value-card">
            {{ formatDate(row.order_success_date) }}
          </div>
        </div>
        <div class="row-card" style="margin-top: 11px;">
          <div style="width:7%"></div>
          <div style="width:60%;display:flex;padding-left:9px">
            สถานะ
            <div :class="'btn-filter ' + row.order_status.toLowerCase()">
              {{ row.order_status }}
            </div>
            </div>
          <div style="width:33%;display:flex">
            <div
              class="view-detail"
              @click="view(row)"
              style="margin-right:10px"
            >
              ดูรายละเอียด
            </div>

            <div @click="printIcon(row)" style="padding-right:5px">
              <v-icon
                v-if=" row.order_status == 'Delivery' "
                v-text="'mdi-printer'"
                style="color:#000000;cursor:pointer"
                size="20"
              ></v-icon>
            </div>


          </div>
        </div>
      </div>
      <div
        style="padding-top:8%;font-size: 40px;color: rgba(0, 0, 0, 0.6);"
        class="table d-flex flex-wrap justify-center"
        v-if="data.length == 0"
      >
        ไม่พบข้อมูลที่ค้นหา กรุณากรอกข้อมูลใหม่
      
      </div>
    </div>

    <!-- <v-dialog persistent v-model="confirmDisable" max-width="454" width="454">
      <v-card>
        <div class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align:center">
              <img class="img" src="@/assets/images/no.png" />
            </div>
            <div style="padding:0px 10px">
              คุณต้องการ
              <span style="font-weight: bold;">ลบหมายเลขคำสั่งซื้อ</span
              >ใช่หรือไม่
            </div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="submit()"
                class="ok"
                style="margin-right:45px"
                >ใช่</v-btn
              >
              <v-btn rounded @click="confirmDisable = false" class="clear"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog> -->


    <v-dialog
      persistent
      v-model="confirmDialog_print"
      max-width="500"
      :width="data.order_status == 'Delivering' ? 600 : 500"
    >
      <v-card>
        <div class="d-dialog">

          <div v-if="loading_print"  style="margin: 200px;z-index:1;position: absolute;">
              <v-progress-circular
              :size="100"
              color="primary"
              indeterminate
            ></v-progress-circular>
            </div>

          <div class="bg-confirm">
            <div style="text-align: center">
              <img class="img" src="@/assets/images/other.png" />
            </div>
            <div style="padding: 0px 20px">{{ confirmText_print }}</div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="submit_print(printParam)"
                class="ok"
                style="color: #fff; margin-right: 45px"
              >
                ใช่
              </v-btn>
              <v-btn rounded @click="confirmDialog_print = false" class="clear"
                >ไม่</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showBsLabelDialog" max-width="500" persistent>
        <v-card class="rounded-xl pa-4" style="border-radius: 20px;">
          <!-- Header -->
          <v-card-title class="d-flex justify-space-between align-center pa-0 mb-4 w-100">
            <div
              class="text-subtitle-1 font-weight-medium"
              style="background-color: #fff; border-radius: 30px; padding: 6px 20px; border: 1px solid #000; font-family: 'Bai Jamjuree';"
            >
              ใบปะหน้าทั้งหมด
            </div>
            <v-btn icon @click="showBsLabelDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <div
              style="width:100%; display: flex; font-weight: bold; background-color: #EDF0FF; border-radius: 8px; padding: 8px 0; margin-bottom: 6px;"
            >
              <div style="width:40px; text-align:center; padding-left: 25px;">#</div>
              <div style="flex:1; text-align:left; text-align:center;">เลขพัสดุ</div>
              <div style="width:60px; text-align:center;"></div>
            </div>

            <v-list-item
              v-for="(fileObj, idx) in bsLabelFiles"
              :key="idx"
            >
              <div style="width:40px; text-align:center; font-weight:600;">{{ idx + 1 }}</div>
              <div style="flex:1; font-family: 'Bai Jamjuree';">
                {{ fileObj.tracking_code || '-' }}
              </div>
              <div style="width:60px; text-align:center;">
                <v-icon size="22" @click="printBsLabelFile(fileObj)">mdi-printer</v-icon>
              </div>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-dialog>
    

    <v-dialog persistent v-model="confirmAdmin" max-width="400" width="400">
      <v-card>
        <div style="font-family:'Bai Jamjuree', sans-serif" class="d-dialog">
          <div class="bg-confirm">
            <div style="text-align:end;padding:15px 20px 20px 20px;">
              <span
                style="cursor: pointer;"
                @click="confirmAdmin = false"
                class="mdi mdi-close"
              ></span>
            </div>
            <div style="padding:0px 10px">
              มีรายการสถานะ Delivery สามารถที่
              <span style="font-weight: bold;">Print label </span><br />จำนวน
              {{ this.show_count }} รายการ
            </div>
          </div>
          <div class="bg-confirm-action">
            <div>
              <v-btn
                rounded
                @click="submit_print(data)"
                class="ok"
                style="margin-right:45px"
                >ตกลง</v-btn
              >
              <v-btn rounded @click="confirmAdmin = false" class="clear"
                >ยกเลิก</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
// import { runInThisContext } from 'vm'
import Vue from "vue";

export default {
  name: 'detail-table',
  props: {
    data: Array,
    dataShipping:Array,
    loading_status: Boolean
  },
  data () {
    return {
      bsLabelFiles: [],
      showBsLabelDialog: false,
      show_count:'',
      printParam: null,
      confirmAdmin: false,
      confirmResend:false,
      confirmDisable: false,
      confirmDialog_print:false,
      loading_print:false,
      select_order: [],
      windowSize: 1366,
      checked: true,
      checkbox_all: false,
      checkbox_true: true,
      count: 0,
      dataPage: this.data,
      deviceType: null,
      calcCardWidth: 20,
      monthsShort: [
        // 'JAN',
        // 'FEB',
        // 'MAR',
        // 'APR',
        // 'MAY',
        // 'JUN',
        // 'JUL',
        // 'AUG',
        // 'SEP',
        // 'OCT',
        // 'NOV',
        // 'DEC'
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
      ],
      actionOrder:'Disable',
      confirmText_print: "",

      mapObj: [],
      page_first: 12,
      page_ohter: 19,

      
      action_list:[
        {
          id : '1',
          txt:'Disable'
        },
       
      ]
    }
  },
  computed: {},
  watch: {
    select_order (newValue) {
      let result = this.data.filter(
        x => x.order_status == 'Complete' && x.disable == 0
      )
      if (result.length > 0) {
        if (result.length !== newValue.length) {
          this.checkbox_all = false
        } else {
          this.checkbox_all = true
        }
      }
    },
    data (newValue) {
      this.select_order = []
      this.checkbox_all = false
    }
  },
  methods: {

    confirmAction () {
      let TheArray = []
      let perc_id = []
      this.mapObj = []
      perc_id.push(this.select_order)
      this.$store
        .dispatch('getOrderDetail', JSON.stringify(this.select_order))
        .then(res => {
          for (let index = 0; index < res.success.data.length; index++) {
            const element = res.success.data[index]
            // console.log(element)
            this.fromData(element)
          }
          TheArray.push(res.success.data)
          Vue.localStorage.set('PRINT_LABEL', JSON.stringify(res.success.data))
        })
        .catch(error => {
          if (error.response.status == 401) {
            sessionStorage.removeItem('user_profile'); 
            sessionStorage.removeItem('token_seesion');
            this.tokenExpired = true
            console.log('Error 401')
          }
        })

      this.show_count = this.select_order.length
      // this.confirmText_print = "คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่";
      this.confirmAdmin = true
      // this.confirmDialog_print = true;

      // this.$emit('submit', this.dataPage)
    },
    checkBox(param1, param2, param3){
      // console.log(param1 + ' ' + param2 + ' '+ param3)
      if((param1 == 0 && param2 == 'Delivery' ) ){
          return true
      }else {
        return false
      }
    
    },
    confirmAction_(){
      if(this.actionOrder == 'Disable'){
          this.confirmDisable = true
      }else {
          this.confirmResend = true
      }
    },
    closeDialog(){
      this.confirmDisable = false
      this.confirmResend = false
    },
    closedialoglabel() {
      this.showBsLabelDialog = false;
      this.bsLabelFiles = [];
    },
    push (param) {
      if (this.select_order.length == 0) {
        // console.log('push')
        this.select_order.push(param)
      } else {
        const found = this.select_order.find(element => element == param)
        // console.log(found)
        if (!found) {
          this.select_order.push(param)
        } else {
          this.select_order = this.select_order.filter(x => x !== param)
        }
      }
    },
    formatDate (val) {
      if (val !== null) {
        let hours = ''
        let min = ''
        let today = new Date(val)
        // const year = today.getFullYear()
        // const fullYear = year
        const year = today.getFullYear()
        const fullYear = year
        // const fullYear = year + 543
        const days = today.getDate()
        const h = today.getHours()
        const m = today.getMinutes()
        const monthName = this.monthsShort[today.getMonth()]

        return (
          days +
          ' ' +
          monthName +
          ' ' +
          fullYear
        )
      } else {
        return val
      }
    },
    OnAction(){
      this.checkbox_all = false
      let result = this.data.filter(
        x => x.order_status == 'Complete' && x.disable == 0 && this.actionOrder == 'Disable'
      )
      let select_order = JSON.parse(JSON.stringify(this.select_order))
        this.select_order = select_order.filter(function (n) {
          return result.indexOf(n) !== -1
        })
    },
    push_all () {
      console.log('push all')
      let result = ''
  
          result = this.data.filter(
            x => x.order_status == 'Delivery' 
          )
          let select_order = JSON.parse(JSON.stringify(this.select_order))
          let purchase = result.map(e => e.purchase_id)
          if (this.checkbox_all) {
            this.select_order = purchase
          } else {
            this.select_order = select_order.filter(function (n) {
              return result.indexOf(n) !== -1
            })
          }
        
    },
    submit () {
      this.confirmResend = false
      this.confirmDisable = false
      this.checkbox_all = false
      if(this.actionOrder == 'Resend'){
          this.select_order.event = 'sendmail'
      }else {
        this.select_order.event = 'disable'
      }
      
      this.$emit('submit', this.select_order)
      this.select_order = []
    },
    find (param) {
      const found = this.select_order.find(element => element == param)
      if (!found) {
        return false
      } else {
        return true
      }
    },
    select_ (param) {
      const found = this.select_order.find(element => element == param)
      if (!found) {
        return false
      } else {
        return true
      }
    },
    view (row) {
      let theArray = []
      theArray.push(row.purchase_id)
      this.$store
        .dispatch('getOrderDetail', JSON.stringify(theArray))
        .then(res => {
          this.$emit('view',res.success.data[0])
        })
        .catch(error => {
          if (error.response.status == 401) {
            sessionStorage.removeItem('user_profile');
            sessionStorage.removeItem('token_seesion');
            this.tokenExpired = true
            console.log('Error 401')
          }
        })


      // console.log("🚀 ~ file: AdminOrderManageDetail.vue ~ line 331 ~ view ~ row", row)
      this.$emit('view', row)
    },
    print (row) {
      console.log('print')
      this.$emit('print', row)
    },

    async printIcon(row) {
      // โหลด order detail ก่อน
      try {
        const res = await this.$store.dispatch('getOrderDetail', JSON.stringify([row.purchase_id]));
        const orderDetail = res.success.data[0];

        // เช็คประเภทขนส่งจาก orderDetail
        if (
          orderDetail.shipping_name === 'Bs Express' ||
          orderDetail.shipping_name === 'BS_EXPRESS' ||
          orderDetail.shipping_channel === 'BS_EXPRESS'
        ) {
          await this.showBsLabelPopup(orderDetail.purchase_id);
          if (this.bsLabelFiles.length > 1) {
            this.showBsLabelDialog = true;
          } else {
            this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่1';
            this.confirmDialog_print = true;
          }
        } else {
          // กรณีจัดส่งเองหรือขนส่งอื่น
          this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่2';
          this.confirmDialog_print = true;
        }
        // เก็บ orderDetail ไว้ใช้ตอนปริ้น
        this.printParam = orderDetail;
      } catch (e) {
        // handle error
        this.confirmText_print = 'ไม่สามารถโหลดข้อมูล order ได้';
        this.confirmDialog_print = true;
      }
    },
    async showBsLabelPopup(purchase_id) {
      const res = await this.$store.dispatch('getBsExpressLabelFiles', { purchase_id });
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        this.bsLabelFiles = res.data.data;
        if (this.bsLabelFiles.length > 1) {
          this.showBsLabelDialog = true;
        } else if (this.bsLabelFiles.length === 1) {
          this.confirmText_print = 'คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่3';
          this.confirmDialog_print = true;
        } else {
          this.bsLabelFiles = [];
          this.showBsLabelDialog = false;
        }
      } else {
        this.bsLabelFiles = [];
        this.showBsLabelDialog = false;
      }
    },
    async printBsLabelFile(fileObj) {
      if (fileObj && fileObj.full_url) {
        window.open(fileObj.full_url, '_blank');
      }
    },
    // printIcon( param ) {

    //   this.mapObj = []
    //   let TheArray = []
    //   let perc_id = []
    //   perc_id.push(param.purchase_id)
    //   this.show_count = 1
    //   // this.confirmDisable = true
    //   this.$store
    //     .dispatch('getOrderDetail', JSON.stringify(perc_id))
    //     .then(res => {
    //       TheArray.push(res.success.data[0])
    //       this.fromData(res.success.data[0])
    //       // Vue.localStorage.set('PRINT_LABEL', JSON.stringify(TheArray))
    //     })
    //     .catch(error => {
    //       if (error.response.status == 401) {
    //         sessionStorage.removeItem('user_profile'); 
    //         sessionStorage.removeItem('token_seesion');
    //         this.tokenExpired = true
    //         console.log('Error 401')
    //       }
    //     })

    //   // console.log(param)
    //   // this.mapObj = [];
    //   // this.fromData(param);
    //   this.printParam = param;
    //   this.confirmText_print = "คุณต้องการพิมพ์ใบปะหน้าใช่หรือไม่";
    //   this.confirmDialog_print = true;   
     
    // },
    maps(po, param, head) {
      const clone = structuredClone(head);
      Object.assign(clone, { page_: po + 1 });
      if (po == 0) {
        const slicedArray = param.slice(0, this.page_first);
        // this.mapObj.set(head ,slicedArray)
        clone.items = slicedArray;
        // console.log('A' ,clone)
        this.mapObj.push(clone);
      } else {
        clone.items = param;
        // console.log('B' , clone)
        this.mapObj.push(clone);
      }
    },
    async submit_print(param) {
      try {
        const Profile = JSON.parse(localStorage.getItem('user_profile'));
        const res = await this.$store.dispatch('getLabelFile', { purchase_id: param.purchase_id });

        if (
          res.data &&
          res.data.success &&
          res.data.data &&
          res.data.data.filename
        ) {
          const filenames = Array.isArray(res.data.data.filename)
            ? res.data.data.filename
            : [res.data.data.filename];

          for (const fname of filenames) {
            const url_file = await this.$store.dispatch('getUrlFile', { url_file: fname });
            window.open(url_file, '_blank');
          }
        } else {
          this.mapObj = [];
          this.fromData(param);
          if (this.mapObj.length === 0) {
            this.mapObj.push(param);
          }
          Vue.localStorage.set('PRINT_LABEL', JSON.stringify(this.mapObj));
          window.open('/#/PrintLabel', '_blank'); 
        }
      } catch (e) {
        this.mapObj = [];
        this.fromData(param);
        if (this.mapObj.length === 0) {
          this.mapObj.push(param);
        }
        Vue.localStorage.set('PRINT_LABEL', JSON.stringify(this.mapObj));
        window.open('/#/PrintLabel', '_blank');
      }
      this.confirmDialog_print = false;
    },
    fromData(data) {
      let count_po = "";
      let count_item = data.items.length;

      if (count_item <= this.page_first) {
        count_po = 1;
      } else if (count_item - this.page_first <= this.page_ohter) {
        count_po = 2;
      } else {
        var sum = (count_item - this.page_first) / this.page_ohter;
        sum = Math.floor(sum) + 1;
        //console.log((count_item - 10) % 15 ,'sum1 =>' , Math.floor(sum)+1)
        if ((count_item - this.page_first) % this.page_ohter != 0) {
          sum = Math.floor(sum) + 1;
        }
        count_po = sum;
      }
      Object.assign(data, { page_count: count_po });
      if (count_po > 1) {
        this.maps(0, data.items, data);
        var a = data.items.slice(this.page_first),
          chunk;
        var po = 0;
        while (a.length > 0) {
          chunk = a.splice(0, this.page_ohter);
          po++;
          this.maps(po, chunk, data);
        }
      } else {
        this.maps(0, data.items, data);
      }
      // this.confirmDisable = true;
    },
   
    onResize () {
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      this.deviceType = window.deviceType()
    }
  } 
 
}
</script>
<style>
</style>
